import { useQuery } from '@tanstack/react-query';

import type { GetInxActionHistoryOutput } from '@infinex/main-service-contract/v2/server/inx';

import type { QueryOptionsV2 } from '../config';
import { getTRPCClient } from '../config';

type InxActionHistoryOptions = QueryOptionsV2<GetInxActionHistoryOutput>;

/**
 * Hook to fetch INX action history for the authenticated user.
 *
 * Returns a list of INX activities including:
 * - Magna claims (patron vesting, team allocations, etc.)
 * - Option exercises (voucher redemptions, sonar early unlocks)
 */
export function useInxActionHistory(options?: InxActionHistoryOptions) {
  return useQuery(
    getTRPCClient().inx.getActionHistory.queryOptions(
      { limit: 100 },
      { ...options }
    )
  );
}
